export default "__VITE_ASSET__1DGaBtY$__"